
import { createStore as _createStore } from 'vuex'
import _ from 'lodash';
import { blankAddHomeForm } from '@/store/constants';

import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import * as homeStore from './homeStore'

export function createStore(router) {
    return _createStore({
        strict: true,
        state: {
            loginLoading: false,
            loggedInUser: null,
            authError: null,
            authStatus: null,
            searchStatus: null,
            searchResults: [],
            moreToLoad: false,
            numSearchResults: 0,
            userSettings: null,
            userSettingsLoading: false,
            blogPosts: [],
            blogStatus: null,
            postToEdit: null,
            shareableIds: null,
            ...homeStore.state,
        },
        actions: {
            ...actions,
            ...homeStore.actions,
        },
        mutations: {
            ...mutations,
            ...homeStore.mutations,
        },
        getters: {
            ...getters,
            ...homeStore.getters,
        },
    });
}